//#region IMPORTS
import {
  setInstoreThemeParams,
  clearInstoreThemeParam,
  clearInstoreThemeParams,
} from "../../features/instoreThemes/instoreThemesSlice";
import { useAppDispatch, useAppSelector } from "../../store/configureStore";
import { ReactNode } from "react";
import MainFilterBarItem from "../_layout/MainFilterBarItem";
import MainFilterBar from "../_layout/MainFilterBar";
//#endregion

//#region INTERFACE
interface Props {
  extensionButtons?: ReactNode;
}
//#endregion

export default function InstoreThemesFilterBar({ extensionButtons }: Props) {
  //#region SETUP
  // Redux
  const dispatch = useAppDispatch();
  const { page, limit, sort, ...params } = useAppSelector(
    ({ instoreThemes }) => instoreThemes.instoreTheme_params
  );
  const { loading } = useAppSelector(({ instoreThemes }) => instoreThemes);
  //#endregion

  //#region RENDER
  return (
    <MainFilterBar
      paramNamesList={params}
      clearAllFiltersHandler={() => dispatch(clearInstoreThemeParams())}
      extensionButtons={extensionButtons}
      clearFilterHandler={(paramName: string) => {
        dispatch(clearInstoreThemeParam(paramName));
      }}
      disabled={loading}
    >
      {/* order_code */}
      <MainFilterBarItem
        filterParameterName="name"
        displayExplanation="Search the instore thems by name"
        clearFilterAction={() => dispatch(clearInstoreThemeParam("name"))}
        selectedValue={params.name}
        filterAction={(value: string) =>
          dispatch(setInstoreThemeParams({ name: value }))
        }
        displayText="Theme name"
        selected={!!params.name}
      />
    </MainFilterBar>
  );
  //#endregion
}
